import type { ReactNode } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Spinner } from '../ui/Feedback';
import { useAuth } from '../../providers/AuthProvider';

export function RequireAuth() {
  const { user, profile, loading } = useAuth();
  const location = useLocation();

  if (loading) return <div className="route-loading"><Spinner label="Verificando sesión…" /></div>;
  if (!user || !profile) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  return <Outlet />;
}

export function RequireAdmin({ children }: { children: ReactNode }) {
  const { profile, loading } = useAuth();
  if (loading) return <Spinner label="Comprobando permisos…" />;
  if (profile?.role !== 'admin') return <Navigate to="/admin" replace />;
  return children;
}
